import React from 'react'
import GameCardFactory from '../../factory/GameCardFactory'
import { useSelector } from 'react-redux'
import { GAME_CARD_VARIANTS } from 'constants/uiConfig'

const InfiniteScrollData = ({
  games,
  toggleFavorite,
  selectedLanguageCode,
  favoriteGamesList
}) => {
  const gameCardVariant = useSelector(state => state?.uiConfig?.general?.gameCardVariant)
  return (
    <>
      <div className={`all-game-listing ${gameCardVariant === GAME_CARD_VARIANTS.V2 ? 'all-game-listing-v2' : ''}`}>
        {games?.rows &&
          games?.rows?.map((game, index) => (
            <GameCardFactory
              game={game}
              index={index}
              toggleFavorite={toggleFavorite}
              selectedLanguageCode={selectedLanguageCode}
              lobby={false}
              key={index}
              isLabeled={game?.isLabelledCategory}
              labelIconUrl={game?.labelIconUrl}
              favoriteGamesList={favoriteGamesList}
            />
          ))}
      </div>
    </>
  )
}

export default InfiniteScrollData
